function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GridCardComponent from '@/components/work_environments/GridCardComponent';
import { mapState } from 'vuex';
import { ROLES_LIST } from '@/js/constants';
var INTERCORP_CODE = '032';
var INTERBANK_COMPANY = {
  code: '000',
  alias: 'Interbank'
};
var COMPANY_NAMES = {
  '000': 'Interbank'
};
export default {
  name: 'UserGroupsPage',
  components: {
    GridCardComponent: GridCardComponent
  },
  data: function data() {
    return {};
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode'])), mapState('attribute', ['groupsByOrg'])), {}, {
    selectedCompany: function selectedCompany() {
      return this.$route.query.company || null;
    },
    isAttributeAdmin: function isAttributeAdmin() {
      var roles = window.userInfo && window.userInfo.userRoles || [];
      return roles.includes(ROLES_LIST.ATTRIBUTE_ADMIN);
    },
    userCompanyCode: function userCompanyCode() {
      return window.userInfo && window.userInfo.companyCode || this.companyCode;
    },
    canViewAllCompanies: function canViewAllCompanies() {
      return this.isAttributeAdmin && this.userCompanyCode === INTERCORP_CODE;
    },
    orgCards: function orgCards() {
      return [INTERBANK_COMPANY].map(function (org) {
        var card = {
          title_es: org.alias,
          title_en: org.alias,
          flex: 4,
          color: '#F1F1F1',
          path: "/attributes/search/user-groups?company=".concat(org.code),
          access: true
        };
        try {
          card.image = "logo_".concat(org.code, ".png");
          require("@/assets/icons/".concat(card.image));
        } catch (e) {
          delete card.image;
          card.urlImage = null;
        }
        return card;
      });
    },
    companyDisplayName: function companyDisplayName() {
      return this.groupsByOrg.company_name || COMPANY_NAMES[this.selectedCompany] || this.selectedCompany;
    },
    userGroupCards: function userGroupCards() {
      return (this.groupsByOrg.groups || []).filter(function (g) {
        return g.alias;
      }).map(function (g) {
        return {
          title_es: g.name_es,
          title_en: g.name_en,
          subtitle_es: g.description_es || '',
          flex: 4,
          color: '#F1F1F1',
          urlImage: g.attribute_group_design || null,
          path: "/attributes/search/list?c=".concat(g.alias),
          access: true
        };
      });
    },
    getBreadcrumbs: function getBreadcrumbs() {
      var crumbs = [{
        text: this.translate('menu.attrs.search_attributes'),
        disabled: false,
        href: '/#/attributes/search'
      }, {
        text: this.translate('attributes.search.user_groups_company_breadcrumb'),
        disabled: !this.selectedCompany,
        href: '/#/attributes/search/user-groups'
      }];
      if (this.selectedCompany) {
        crumbs.push({
          text: this.companyDisplayName,
          disabled: true
        });
      }
      return crumbs;
    }
  }),
  watch: {
    selectedCompany: {
      immediate: true,
      handler: function handler(code) {
        if (code) {
          this.enforceAccessAndLoad(code);
          return;
        }
        this.redirectToOwnCompanyIfNeeded();
      }
    },
    canViewAllCompanies: function canViewAllCompanies(canView) {
      if (!canView) {
        this.redirectToOwnCompanyIfNeeded();
      }
    },
    userCompanyCode: function userCompanyCode(code) {
      if (!code) return;
      if (this.selectedCompany) {
        this.enforceAccessAndLoad(this.selectedCompany);
        return;
      }
      this.redirectToOwnCompanyIfNeeded();
    }
  },
  created: function created() {
    this.redirectToOwnCompanyIfNeeded();
  },
  methods: {
    redirectToOwnCompanyIfNeeded: function redirectToOwnCompanyIfNeeded() {
      if (this.selectedCompany || this.canViewAllCompanies || !this.userCompanyCode) return false;
      this.$router.replace("/attributes/search/user-groups?company=".concat(this.userCompanyCode));
      return true;
    },
    enforceAccessAndLoad: function enforceAccessAndLoad(code) {
      if (!code) return;
      if (!this.canViewAllCompanies && !this.userCompanyCode) return;
      if (!this.canViewAllCompanies && code !== this.userCompanyCode) {
        var ownPath = this.userCompanyCode ? "/attributes/search/user-groups?company=".concat(this.userCompanyCode) : '/attributes/search/user-groups';
        this.$router.replace(ownPath);
        return;
      }
      this.$store.dispatch('attribute/getAttributeGroupsByOrg', code);
    }
  }
};